import React from 'react';
import { useParams } from 'react-router-dom';

import RegisterPage from 'components/registrationPage';
import { useEventManipulate } from './v2/useEventManipulate';

import 'styles/scss/routes/event.scss';

export default function Register(props) {
  const params = useParams();
  const { title, customStyle } = useEventManipulate(props);

  return (
    <main className="event-page" style={customStyle}>
      <RegisterPage eventId={params.eventId} eventTitle={title()}></RegisterPage>
    </main>
  );
}
